/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  Divider,
  Typography,
  Zoom,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";

import { useApolloClient } from "@apollo/client";
import styled from "@emotion/styled";
import Pagination from "@mostrans/web-components/components/base/Pagination";
import Select from "@mostrans/web-components/components/base/Select";
import Tabs, { TabItem } from "@mostrans/web-components/components/base/Tabs";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { isEmpty } from "lodash";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import CardDetail from "../../../components/Card/CardDetail";
import {
  getMasterStatusCandidate,
  getOpportunitiesByCandidateID,
} from "../../../graphql/query";
import { getOpportunityByCandidateID } from "../../../shared/atom/detailCandidate";
import {
  getDetailJobByCandidateID,
  globalLoadingAtom,
} from "../../../shared/globalStates";
import Profile from "./Profile";
function Dashboard() {
  const client = useApolloClient();
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [status, setStatus] = useState([]);
  const [selected, setSelected] = useState();
  const [filter, setFilter] = useState();
  const [listApply, setListApply] = useRecoilState(getOpportunityByCandidateID);
  const [open, setOpen] = useState(false);
  const setData = useSetRecoilState(getDetailJobByCandidateID);
  const fullScreen = useMediaQuery(useTheme().breakpoints.down("md"));
  const [currentPage, setCurrentPage] = useState(0);
  const [nextPage, setNextPage] = useState(6);
  const [show, setShow] = useState("List Lamaran");

  useEffect(() => {
    setLoading(true);
    getOpportunitiesByCandidateID(client).then(setListApply);
    getMasterStatusCandidate(client).then(setStatus);
  }, []);

  useEffect(() => {
    setLoading(false);
    setFilter(listApply);
  }, [status, listApply]);

  useEffect(() => {
    if (!isEmpty(listApply)) {
      if (!isEmpty(selected) && selected != null) {
        const filter = listApply.filter((e) => {
          return e.StatusCandidate.StatusCandidate.status === selected;
        });
        setFilter(filter);
      } else {
        setFilter(listApply);
      }
    } else {
      setFilter(listApply);
    }
  }, [selected]);

  const handleClose = () => setOpen(false);

  const media = useMediaQuery("(max-width:900px)");

  const StyledTab = styled(TabItem)`
    width: 50%;
  `;

  return (
    <React.Fragment>
      <Box display={fullScreen ? "block" : "none"}>
        <Tabs>
          <StyledTab
            current={show === "List Lamaran"}
            onClick={() => setShow("List Lamaran")}
          >
            My Applications
          </StyledTab>
          <StyledTab
            current={show === "Profile"}
            onClick={() => setShow("Profile")}
          >
            Profile
          </StyledTab>
        </Tabs>
      </Box>

      <Grid container spacing={2} pt="25px" px="10px">
        <Grid
          sx={{
            display: show === "List Lamaran" || !fullScreen ? "block" : "none",
          }}
          item
          xs={12}
          sm={12}
          md={12}
          lg={3}
          xl={3}
        >
          <Box
            maxWidth="lg"
            disableGutters={media}
            sx={{
              margin: media && "10px",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: "4px",
            }}
            paddingX="10px"
          >
            <Typography
              marginBottom={2}
              textAlign="center"
              pt={2}
              textTransform="uppercase"
              variant="h2"
              component="h2"
            >
              My Applications
            </Typography>
            <Select
              className="mb-2"
              placeholder="Filter status"
              isClearable
              onChange={(e) => {
                if (e) {
                  setSelected(e.value);
                } else {
                  setSelected(null);
                }
              }}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={status.map((value) => ({
                label: value.status,
                value: value.status,
              }))}
            ></Select>
            {filter?.slice(nextPage - 6, (currentPage + 1) * 6).map((list) => (
              <Card
                onClick={() => {
                  setData(list);
                  setOpen(true);
                }}
                className="shadow-soft-s4-hover"
                variant="outlined"
                sx={{ cursor: "pointer", mb: "25px" }}
                key={list.id}
              >
                <CardContent>
                  <Typography
                    variant="h4"
                    component="h4"
                    color="primary"
                    sx={{ mb: "15px" }}
                  >
                    {list.title}
                  </Typography>
                  <div className="text-textSecondary font-size-small">
                    <span
                      className="material-icons"
                      style={{ paddingRight: "10px" }}
                    >
                      schedule
                    </span>
                    {list.StatusCandidate.created_date}
                  </div>
                  <Chip
                    color={
                      list.StatusCandidate.StatusCandidate.status ===
                      "Not Suitable"
                        ? "danger"
                        : "primary"
                    }
                    label={list.StatusCandidate.StatusCandidate.status}
                    sx={{ marginTop: "15px" }}
                  />
                </CardContent>
              </Card>
            ))}
          </Box>
          <div
            className="pagination"
            style={{
              margin: "20px 0",
              justifyContent: "center",
              display: filter?.length >= 6 ? "flex" : "none",
            }}
          >
            <Pagination
              totalData={filter?.length}
              currentPage={currentPage}
              onPageChange={({ page }) => {
                setCurrentPage(page);
                setNextPage(page * 6);
              }}
              rowsPerPage={6}
              showResult={false}
              showFirstLastButton={true}
              showRowsPerPageOptions={false}
              showPageNumber={true}
            />
          </div>
        </Grid>
        <Grid
          sx={{
            display: show === "Profile" || !fullScreen ? "block" : "none",
          }}
          item
          xs={12}
          sm={12}
          md={12}
          lg={9}
          xl={9}
        >
          {/* <Divider
            orientation="vertical"
            sx={{ mx: "10px", borderRightWidth: 5 }}
            flexItem
          /> */}
          <Profile />
        </Grid>
      </Grid>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-card-details"
        closeAfterTransition
      >
        <DetailJob handleOpen={setOpen} />
      </Dialog>
    </React.Fragment>
  );
}

export default Dashboard;

export const DetailJob = ({ handleOpen }) => {
  const data = useRecoilValue(getDetailJobByCandidateID);
  const [open, setOpen] = useState(false);
  const [id, setID] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const listStatus = [
    {
      id: 1,
      name: "CV Sent",
      status: "Your CV successfully submitted.",
      icon: "send",
    },
    {
      id: 2,
      name: "On Review",
      status: "Your CV is being reviewed by HRD.",
      icon: "preview",
    },
    {
      id: 3,
      name: "Psikotest",
      status:
        "Go to the assessment page and start working on the psychological test.",
      icon: "assignment",
    },
    {
      id: 4,
      name: "Interview",
      status:
        "Yeay! You will be contacted via email or whatsapp for an interview.",
      icon: "question_answer",
    },
    {
      id: 5,
      name: "Suitable",
      status: "Congratulations! You have been accepted in this position.",
      icon: "how_to_reg",
    },
    {
      id: 6,
      name: "Not Suitable",
      status: "Sorry, You are not suitable for this position.",
      icon: "person_off",
    },
  ];
  return (
    <Card sx={{ overflow: "auto" }}>
      <CardContent>
        <Box className="header__cardDetail">
          <div className="d-flex justify-content-between">
            <h3 className="text-primary-main" style={{ margin: "10px 0" }}>
              {data.title}
            </h3>
            <div
              className="bg-neutral-n2-hover text-center d-flex"
              onClick={() => handleOpen(false)}
              style={{
                margin: "auto 0",
                borderRadius: "50px",
                cursor: "pointer",
                height: "50px",
                width: "50px",
              }}
            >
              <span className="material-icons m-auto"> close </span>
            </div>
          </div>
          <div
            className="date__sent"
            style={{ display: "flex", margin: "10px 0" }}
          >
            <span
              className="material-icons text-primary-main"
              style={{ paddingRight: "5px" }}
            >
              event_available
            </span>
            <Typography p="1px">
              Submitted on {data.StatusCandidate.created_date}
            </Typography>
          </div>
          <div
            className="date__updated"
            style={{ display: "flex", margin: "10px 0" }}
          >
            <span
              className="material-icons text-primary-main"
              style={{ paddingRight: "5px" }}
            >
              update
            </span>
            <Typography p="1px">
              Application status is last updated on {"  "}
              {data.StatusCandidate.updated_date}
            </Typography>
          </div>
          <Box display="flex" gap={5}>
            <div
              className="job__divisi"
              style={{ display: "flex", margin: "10px 0" }}
            >
              <span
                className="material-icons text-primary-main"
                style={{ paddingRight: "5px" }}
              >
                business
              </span>
              <Typography p="1px">{data.Division.division}</Typography>
            </div>
            <div
              className="job__location"
              style={{ display: "flex", margin: "10px 0" }}
            >
              <span
                className="material-icons text-primary-main"
                style={{ paddingRight: "5px" }}
              >
                location_on
              </span>
              <Typography p="1px">{data.Location.nama}</Typography>
            </div>

            <div
              className="job__level"
              style={{ display: "flex", margin: "10px 0" }}
            >
              <span
                className="material-icons text-primary-main"
                style={{ paddingRight: "5px" }}
              >
                work
              </span>
              <Typography p="1px">{data.job_level}</Typography>
            </div>
          </Box>
        </Box>
        <Divider sx={{ marginY: "10px" }} />
        <Box>
          <Timeline>
            {listStatus
              .slice(0, data?.StatusCandidate?.StatusCandidate?.id)
              .map((item) => {
                return (
                  <TimelineItem key={item.id} sx={{ minWidth: "540px" }}>
                    <TimelineOppositeContent
                      sx={{ m: "auto 0" }}
                      align="right"
                      variant="body2"
                      color="text.secondary"
                    >
                      <Typography
                        fontSize={12}
                        fontStyle="oblique"
                        sx={{
                          textDecoration:
                            !(
                              data.StatusCandidate.StatusCandidate.id >= item.id
                            ) ||
                            (data.StatusCandidate.StatusCandidate.id >
                              item.id &&
                              data.StatusCandidate.StatusCandidate.id === 6 &&
                              "line-through"),
                        }}
                      >
                        {item.status}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineConnector
                        sx={{
                          bgcolor:
                            data.StatusCandidate.StatusCandidate.id >=
                              item.id && "primary.main",
                        }}
                      />
                      <TimelineDot
                        sx={{
                          bgcolor:
                            data.StatusCandidate.StatusCandidate.id === 6
                              ? "#D7272D"
                              : data.StatusCandidate.StatusCandidate.id >=
                                item.id
                              ? "#0A8C4A"
                              : "#bdbdbd",
                        }}
                      >
                        <span className="material-icons">{item.icon}</span>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent sx={{ m: "auto 0", py: "12px", px: 2 }}>
                      <Typography
                        variant="h6"
                        component="span"
                        sx={{
                          textDecoration:
                            data.StatusCandidate.StatusCandidate.id > item.id &&
                            data.StatusCandidate.StatusCandidate.id === 6 &&
                            "line-through",
                        }}
                      >
                        {item.name}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
          </Timeline>
        </Box>
        <Divider sx={{ marginY: "10px" }} />
        <Box
          onClick={() => {
            setOpen(true);
            setID(data.id);
          }}
          className="footer__cardDetail"
          style={{
            textAlign: "center",
          }}
        >
          <div
            className="footer-contents"
            style={{ display: "inline-flex", cursor: "pointer" }}
          >
            <h6
              className="text-primary-main"
              style={{ verticalAlign: "text-bottom", width: "100%" }}
            >
              View complete job details
            </h6>
            <span className="material-icons text-primary-main"> east</span>
          </div>
        </Box>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-card-details"
          closeAfterTransition
        >
          <Zoom in={open} style={{ transitionDelay: open ? "50ms" : "0ms" }}>
            <div>
              <CardDetail id={id} setOpen={setOpen} />
            </div>
          </Zoom>
        </Dialog>
      </CardContent>
    </Card>
  );
};
